import { SectionNewsletterV2Props } from '@portfolio/models'
import { styled } from '@portfolio/styles'
import { PortableText, KlaviyoForm } from '@portfolio/components'

const Wrap = styled('div', {
  padding: 'calc($headerHeight + $96) $20',
  marginBottom: '$mobileSectionMarginL',
  marginTop: 0,
  '@lg': {
    marginTop: 0,
    marginBottom: '$desktopSectionMarginL',
  },
  display: 'grid',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  backgroundColor: '$black',
  color: '$white',

  '@md': {
    padding: '264px $32',
  },
})

const Heading = styled('h2', {
  projectFont: 'heading02',
  marginBottom: '$64',
  maxWidth: '724px',
  textAlign: 'center',
})

const NewsletterWrap = styled('div', {
  display: 'grid',
  gap: '$8',
  justifySelf: 'center',
  width: '100%',

  '@md': {
    width: '50vw',
  },
  '@lg': {
    width: '30vw',
  },
})

const NewsletterForm = styled('div', {
  margin: 0,
})

const NewsletterPrivacyPolicyInfo = styled('div', {
  projectFont: 'ui04',
  textAlign: 'center',
  color: '$white_06',
  a: {
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
  },
})
export const SectionNewsletterV2 = ({
  title,
  anchorId,
  privacyPolicyInfo,
  klaviyoFormId,
}: SectionNewsletterV2Props) => {
  return (
    <Wrap {...(anchorId && { id: anchorId })}>
      <Heading>{title}</Heading>
      <NewsletterWrap>
        <NewsletterForm>
          <KlaviyoForm formId={klaviyoFormId} />
        </NewsletterForm>

        {privacyPolicyInfo && (
          <NewsletterPrivacyPolicyInfo>
            <PortableText value={privacyPolicyInfo} appearance="plain" />
          </NewsletterPrivacyPolicyInfo>
        )}
      </NewsletterWrap>
    </Wrap>
  )
}
